
import { makeAutoObservable } from 'mobx';
import { Config,Util,Storage } from '@xt/xtbase';
import { get_priceCurrencyConvert,get_currencies,get_recommendedCurrencies,get_balances } from '@/api/v4/balance';
const {Big} = Util;
import icon404 from "assets/images/common/icon404.png";

export default class Fund {

  /* 当前法币/辅助价格表 */
  assist:any = {};
  assistPriceMap: { [key: string]: string } = {};
  assistPriceTimer: any = null;

  /* 币种配置表 */
  currencyList: [any] = [null];
  currencyListMd5: string = "";
  currencyMap: {} = {};
  recommendedCurrencyList: [any] = [null];
  recommendedCurrencyListMd5: string = "";
  recommendedCurrencyMap: {} = {};
  loading:boolean = false;
  recommendedLoading:boolean = false;

  totalUsdtAmount: 0;
  totalBtcAmount: 0;
  assets: [any] = [null];
  balancesTimer: any = null;

  async fetchBalances() {
    this.clearBalancesTimer();

    const result: any = await get_balances().catch(()=>{}).finally(() => {
      this.balancesTimer = setTimeout(() => {
        this.fetchBalances();
      }, 5000);
    });

    if (result) {
      this.totalUsdtAmount = result.totalUsdtAmount;
      this.totalBtcAmount = result.totalBtcAmount;
      this.assets = result.assets;
      this.balancesTimer = result.balancesTimer;
    }
  }

  clearBalancesTimer() {
    if (this.balancesTimer) {
      clearTimeout(this.balancesTimer);
    }
  }

  getBalanceByCurrencyId(currencyId){
    for(var key in this.assets){
      if(this.assets[key] && this.assets[key].currencyId == currencyId)
        return this.assets[key].availableAmount || 0;
    }
    return 0;
  }
  getBalanceByCurrencyName(currencyName){
    currencyName && (currencyName = currencyName.toLowerCase());
    for(var key in this.assets){
      if(this.assets[key] && this.assets[key].currency == currencyName)
        return this.assets[key].availableAmount || 0;
    }
    return 0;
  }

  constructor() {
    makeAutoObservable(this);
  }

  init(appState){
    //this.setAssist(appState.currency);
    const currencyList = Storage.get("currencyList") || {};
    const recommendedCurrencyList = Storage.get("recommendedCurrencyList") || {};
    this.currencyList = currencyList.currencies || [];
    this.currencyListMd5 = currencyList.version || "";
    this.currencyMap = {};
    this.currencyList && this.currencyList.forEach((c)=>{
      this.currencyMap[c.currency] = c;
    });
    this.recommendedCurrencyList = recommendedCurrencyList.currencies || [];
    this.recommendedCurrencyListMd5 = recommendedCurrencyList.version || "";
    this.recommendedCurrencyMap = {};
    this.recommendedCurrencyList && this.recommendedCurrencyList.forEach((c)=>{
      this.recommendedCurrencyMap[c.currency] = c;
    });
    this.getCurrencyList();
    this.getRecommendedCurrencyList();
  }

  setAssist(data: string) {
    const assist = Config.assistConfig.find((obj) => obj.key === data);
    if(assist)
    {
      this.assist = assist;
      this.fetchAssistPriceMap();
    }
  }

  setAssistPriceMap(data: any) {
    if (data) {
      this.assistPriceMap = data;
    }
  }

  async fetchAssistPriceMap() {
    this.clearAssistPriceTimer();

    const result: any = await get_priceCurrencyConvert({
      params: { 
        converts: this.assist.key == "btc" ? this.assist.key : this.assist.key + ",btc" 
      }
    }).catch(()=>{}).finally(() => {
      this.assistPriceTimer = setTimeout(() => {
        this.fetchAssistPriceMap();
      }, 5000);
    });

    if (result) {
      this.setAssistPriceMap(result);
    }
  }

  clearAssistPriceTimer() {
    if (this.assistPriceTimer) {
      clearTimeout(this.assistPriceTimer);
    }
  }

  async getCurrencyList() {
    if(this.loading)
      return;
    this.loading = true;

    const data: any = await get_currencies({
      params: {
        version: this.currencyListMd5,
      }
    }).catch(()=>{}).finally(() => {
      this.loading = false;
    });

    if (data && data.currencies && data.version !== this.currencyListMd5) {
      console.log("get_currencies update】", data);
      this.currencyList = data.currencies;
      this.currencyListMd5 = data.version;
      this.currencyMap = {};
      this.currencyList && this.currencyList.forEach((c)=>{
        this.currencyMap[c.currency] = c;
      })
      Storage.set("currencyList", data);
    }
  }

  async getRecommendedCurrencyList() {
    if(this.recommendedLoading)
      return;
    this.recommendedLoading = true;

    const data: any = await get_recommendedCurrencies({
      params: {
        version: this.recommendedCurrencyListMd5,
      }
    }).catch(()=>{}).finally(() => {
      this.recommendedLoading = false;
    });

    const nextCurrencies = Array.isArray(data?.currencies) ? data.currencies : [];
    const prevCurrencies = Array.isArray(this.recommendedCurrencyList) ? this.recommendedCurrencyList : [];
    const versionChanged = data?.version !== this.recommendedCurrencyListMd5;
    const contentChanged = JSON.stringify(nextCurrencies) !== JSON.stringify(prevCurrencies);

    if (nextCurrencies.length > 0 && (versionChanged || contentChanged)) {
      this.recommendedCurrencyList = nextCurrencies;
      this.recommendedCurrencyListMd5 = data.version || "";
      this.recommendedCurrencyMap = {};
      this.recommendedCurrencyList.forEach((c)=>{
        this.recommendedCurrencyMap[c.currency] = c;
      });
      Storage.set("recommendedCurrencyList", {
        ...data,
        currencies: nextCurrencies,
      });
    }
  }

  getCurrencyDisplayName(currency) {
    var obj = this.currencyMap[currency];
    if (obj && obj.displayName)
      return obj.displayName;
    return currency ? currency.toUpperCase() : "";
  }

  getCurrencyIcon(currency){
    var obj = this.currencyMap[currency];
    if(!obj)
      return icon404;
    return this.currencyMap[currency].logo || icon404;
  }

  getCurrencyPrecision(currency){
    var obj = this.currencyMap[currency];
    if(!obj)
      return 8;
    return this.currencyMap[currency].maxPrecision || 8;
  }

  /**
   * 获取资产指定币种折合价
   * @param number 数量，譬如 200
   * @param coin 币种
   * @param targetCoin 货币类型，默认是当前货币类型
   * @param thousands Boolean，返回字符串是否千分位分割，默认否
   */
   getCoinValue(number: string | number, coin: string, targetCoin?: string, thousands?: string) {
    !number && (number = 0);
    let result = "0";

    let referConfig = this.assist || { key: "cny" }; // 获取辅助货币的配置
    let referCoin = targetCoin || referConfig.key; // 传入的优先 否则用默认的

    if (this.assistPriceMap) {
      /*
      let coinPrice = state.assistPrice[coin.toLowerCase()]; // 获取资产货币的折合价格
      let referPrice = state.assistPrice[referCoin]; // 获取辅助货币的折合价格
      referCoin === "cny" && (referPrice = 1); //若辅助币种是人民币则辅助价格为1，接口数据好像没有

      if (+coinPrice && +referPrice) {
        //折算并格式化小数位
        result = +Big(number).times(coinPrice).div(referPrice).toFixed();
      }
       */

      const doc = this.assistPriceMap[coin];
      if (doc && doc[referCoin]) result = Big(number).times(doc[referCoin]).toFixed();
    }

    if (["btc"].includes(referCoin)) {
      if (Big(result).minus(0.00000001).toNumber() >= 0 || Big(result).minus(0).toNumber() === 0) {
        return thousands ? Big(result).toFixedCy(8) : Big(result).toFixed(8);
      }
    } else if (referCoin === "krw" || referCoin === "vnd") {
      if (Big(result).minus(1).toNumber() >= 0 || Big(result).minus(0).toNumber() === 0) {
        return thousands ? Big(result).toFixedCy(0) : Big(result).toFixed(0);
      }
    } else {
      const minus01 = Big(result).minus(0.01).toNumber();
      const minus0001 = Big(result).minus(0.0001).toNumber();
      const minus000001 = Big(result).minus(0.000001).toNumber();
      const minus00000001 = Big(result).minus(0.00000001).toNumber();
      const minus000000000001 = Big(result).minus(0.000000000001).toNumber();
      const minus00000000000001 = Big(result).minus(0.00000000000001).toNumber();
      const minus0000000000000001 = Big(result).minus(0.0000000000000001).toNumber();
      if (minus01 >= 0 || Big(result).minus(0).toNumber() === 0) {
        return thousands ? Big(result).toFixedCy(2) : Big(result).toFixed(2);
      }
      if (minus0001 >= 0 && minus01 < 0) {
        return thousands ? Big(result).toFixedCy(4) : Big(result).toFixed(4);
      }
      if (minus000001 >= 0 && minus0001 < 0) {
        return thousands ? Big(result).toFixedCy(6) : Big(result).toFixed(6);
      }
      if (minus00000001 >= 0 && minus000001 < 0) {
        return thousands ? Big(result).toFixedCy(8) : Big(result).toFixed(8);
      }
      if (minus000000000001 >= 0 && minus00000001 < 0) {
        return thousands ? Big(result).toFixedCy(10) : Big(result).toFixed(10);
      }
      if (minus00000000000001 >= 0 && minus000000000001 < 0) {
        return thousands ? Big(result).toFixedCy(12) : Big(result).toFixed(12);
      }
      if (minus0000000000000001 >= 0 && minus00000000000001 < 0) {
        return thousands ? Big(result).toFixedCy(14) : Big(result).toFixed(14);
      }
    }
    return thousands ? Big(result).toFixedMaxCy(16) : Big(result).toFixedMax(16);
   }
}
